import React, { useState } from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Popper from "@mui/material/Popper";
import Box from "@mui/material/Box";
import "./popper.scss";

export const CustomPopper = ({
  open,
  anchorEl,
  position,
  handleClose,
  ...props
}) => {
  const [arrowRef, setArrowRef] = useState(null);

  return (
    <Popper
      className="custom-popper"
      open={open}
      anchorEl={anchorEl}
      placement={position}
      {...props}
      modifiers={[
        {
          name: "flip",
          enabled: true,
          options: {
            altBoundary: true,
            rootBoundary: "document",
            padding: 8,
          },
        },
        {
          name: "preventOverflow",
          enabled: true,
          options: {
            altAxis: true,
            altBoundary: false,
            tether: true,
            rootBoundary: "document",
            padding: 8,
          },
        },
        {
          name: "arrow",
          enabled: true,
          options: {
            element: arrowRef,
          },
        },
      ]}
    >
      {open ? <span className="popper-arrow" ref={setArrowRef} /> : null}
      <ClickAwayListener onClickAway={handleClose}>
        <Box>{props.children}</Box>
      </ClickAwayListener>
    </Popper>
  );
};
